/* eslint-disable import/prefer-default-export */
import { isWhitelistedEmail } from '@mercadoni/sinister/dist/cjs/shared/utils';

export const validateStockWarning = clientModel => {
  const { enable = false } = clientModel?.stockWarning || {};
  const validateStockObject = {
    ...clientModel?.stockWarning,
    enable: isWhitelistedEmail('allowReplacements') || enable,
  };

  return validateStockObject;
};
